import { useCallback, useEffect } from 'react';
import { LoggedState } from '../models/AuthModelsCommon';
import { missionsActions } from '../store/missionsSlice';
import { useAppDispatch, useAppSelector } from './store-hook';

/** Only Map and My Missions opt in, after the survey has lost focus. */
export default function useMissionCompletionPrompt(enabled: boolean) {
  const dispatch = useAppDispatch();
  const auth = useAppSelector(state => state.auth);
  const prompt = useAppSelector(state => state.missions.completionPrompt);
  const visible = enabled && auth.logged === LoggedState.Logged && !!auth.idToken &&
    !!prompt && prompt.userId === auth.user?.uid;
  const dismiss = useCallback(() => {
    if (prompt) dispatch(missionsActions.dismissMissionCompletionPrompt(prompt));
  }, [dispatch, prompt]);

  // A displayed prompt is consumed on dismissal or departure. A pending prompt
  // stays queued while the survey/completion page is still on screen.
  useEffect(() => {
    if (visible) return dismiss;
  }, [visible, dismiss]);

  return { visible, dismiss };
}
